import React from 'react'

interface TimeAgoProps {
  timestamp: any
  showTooltip?: boolean
  className?: string
  style?: React.CSSProperties
}

const TimeAgo: React.FC<TimeAgoProps> = ({ 
  timestamp, 
  showTooltip = true, 
  className = '', 
  style = {} 
}) => {
  const formatDate = (timestamp: any) => {
    if (!timestamp) return 'Not scanned yet'
    
    try {
      if (timestamp.toDate) {
        return timestamp.toDate().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
      return 'Invalid date'
    } catch (error) {
      return 'Invalid date'
    }
  }

  const getTimeAgo = (timestamp: any) => {
    if (!timestamp) return 'Not scanned yet'
    
    try {
      let date: Date
      
      if (timestamp.toDate) {
        date = timestamp.toDate()
      } else if (timestamp instanceof Date) {
        date = timestamp
      } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
        date = new Date(timestamp)
      } else {
        return 'Invalid date'
      }

      const now = new Date()
      const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)

      if (diffInSeconds < 60) {
        return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`
      }

      const diffInMinutes = Math.floor(diffInSeconds / 60)
      if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`
      }

      const diffInHours = Math.floor(diffInMinutes / 60)
      if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`
      }

      const diffInDays = Math.floor(diffInHours / 24)
      if (diffInDays < 30) {
        return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`
      }

      const diffInMonths = Math.floor(diffInDays / 30)
      if (diffInMonths < 12) {
        return `${diffInMonths} month${diffInMonths !== 1 ? 's' : ''} ago`
      }

      const diffInYears = Math.floor(diffInMonths / 12)
      return `${diffInYears} year${diffInYears !== 1 ? 's' : ''} ago`
    } catch (error) {
      return 'Invalid date'
    }
  }

  return (
    <div 
      className={`d-flex align-items-center ${className}`}
      title={showTooltip && timestamp ? formatDate(timestamp) : undefined}
      style={style}
    >
      {getTimeAgo(timestamp)}
    </div>
  )
}

export default TimeAgo
